/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DuplicationTourRequest } from '../../models/duplication-tour-request';
import { Tour } from '../../models/tour';

export interface DuplicateTour$Params {
      body: DuplicationTourRequest
}

export function duplicateTour(http: HttpClient, rootUrl: string, params: DuplicateTour$Params, context?: HttpContext): Observable<StrictHttpResponse<Tour>> {
  const rb = new RequestBuilder(rootUrl, duplicateTour.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tour>;
    })
  );
}

duplicateTour.PATH = '/api/v1/tours/duplicate';
